<template>
  <v-container class="pa-0" fluid>
    <!-- Snackbar -->
    <SnackbarMessage ref="snackbar" />

    <!-- Layout paginado -->
    <PaginatedLayout :items="incomes" @update-page="updatePage" class="pb-15">
      <!-- Header -->
      <template v-slot:header>
        <DeltiaCard>
          <!-- Columna para el título -->
          <v-col cols="12" md="7" class="mb-2">
            <p class="display-1 font-weight-bold mb-0 pb-0">
              Ingresos
            </p>
          </v-col>
          <!-- Columna para el botón de agregar usuarios -->
          <v-col cols="12" md="5" class="mb-2">
            <NewIncome
              @update-income="onNewIncome"
              @income-error="onIncomeError"
            ></NewIncome>
          </v-col>
          <!-- Columna para el selector de sucursales -->
          <v-col cols="12">
            <BranchSelector @branch-selected="branchChange" />
          </v-col>
        </DeltiaCard>
      </template>
      <!-- Items -->
      <template v-slot:items>
        <!-- Pantalla de carga -->
        <LoadingLayout v-if="isLoading">
          <LinearLoading>
            Cargando ingresos
          </LinearLoading>
        </LoadingLayout>
        <!-- Ingresos -->
        <template v-else>
          <!-- Mostrar item para el ingreso -->
          <IncomeItem
            v-for="item in incomes.docs"
            :key="item._id"
            :amount="item.amount"
            :movementId="item._id"
            :description="item.description"
            :branchId="item.branch_id"
            :productId="item.product_id"
            :userId="item.user_id"
            :date="item.created_at"
            @income-deleted="onIncomeDeleted"
            @income-error="onIncomeError"
          />
        </template>
      </template>
    </PaginatedLayout>
  </v-container>
</template>

<script>
// Importar componentes
import LoadingLayout from "@/layouts/LoadingLayout";
import LinearLoading from "@/components/Loading/Linear";
import PaginatedLayout from "@/layouts/PaginatedLayout";
import SnackbarMessage from "@/components/SnackbarMessage";
import NewIncome from "@/components/movements/modals/NewIncome";
import IncomeItem from "@/components/movements/IncomeItem";
import BranchSelector from "@/components/BranchSelector";
import DeltiaCard from "@/components/DeltiaCard";

// Importar dependencias
import { mapGetters } from "vuex";

// importar sevicios
import MovementsServices from "@/services/MovementsServices";

export default {
  components: {
    LinearLoading,
    LoadingLayout,
    SnackbarMessage,
    PaginatedLayout,
    NewIncome,
    IncomeItem,
    BranchSelector,
    DeltiaCard
  },
  data: function() {
    return {
      incomes: { docs: [] },
      isLoading: true
    };
  },
  computed: {
    ...mapGetters(["getProfile"])
  },
  methods: {
    // Función para actualizar los items
    updatePage: async function(page = 1) {
      try {
        // Mostrar pantalla de carga
        this.isLoading = true;

        // Verificar si se quieren obtener los ingresos de todas las sucursales
        if (this.selectedBranchId === -1) {
          // Realizar petición para todas las sucursales
          this.incomes = await MovementsServices.getIncomeByBusinessId(
            this.getProfile.business_id,
            page
          );
        } else if (this.selectedBranchId) {
          // Realizar petición para la sucursal seleccionada
          this.incomes = await MovementsServices.getIncomeByBranchId(
            this.selectedBranchId,
            page
          );
        }

        // Ocultar pantalla de carga
        this.isLoading = false;
      } catch (err) {
        // Regresamos el error en dado caso de que exista
        this.onIncomeError(err.message);
      }
    },
    branchChange: async function(id) {
      // Modificar la sucursal seleccionada
      this.selectedBranchId = id;

      // Obtener los datos de ventas
      await this.updatePage();
    },
    onNewIncome: async function() {
      // Mostrar mensaje de éxito
      this.$refs.snackbar.showSuccessMessage("Ingreso registrado con éxito");

      // Obtener ingresos
      await this.updatePage();
    },
    onIncomeError: function(errorMessage) {
      // Mostrar error
      this.$refs.snackbar.showError(errorMessage);
    },
    onIncomeDeleted: async function() {
      // Mostrar mensaje de éxito
      this.$refs.snackbar.showSuccessMessage("Ingreso eliminado con éxito");

      // Obtener ingresos
      await this.updatePage();
    }
  }
};
</script>
